module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "engagement"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "col-12 page-title"
  }, [_vm._v("\n      ENGAGEMENTS\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "alternating-divs col-12 row",
    attrs: {
      "id": "engagement-content"
    }
  }, [_c('div', {
    staticClass: "col-12 white-block"
  }, [_c('h2', {
    staticClass: "pb-1"
  }, [_vm._v("UN TRAVAIL D'ÉQUIPE À VOTRE ÉCOUTE ET À VOTRE SERVICE")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_vm._v("\n             Il commence par un "), _c('b', [_vm._v("diagnostic personnalisé, approfondi et clair")]), _vm._v(". Nous prendrons le temps de faire le point sur vos "), _c('b', [_vm._v("souhaits")]), _vm._v(". Lors de la 1ère consultation nous vous demandons de venir avec toutes les pièces du dossier que vous a remis votre chirurgien dentiste ou à défaut les radios que vous avez pu réaliser. Si besoin, pour compléter les informations obtenus lors de l’"), _c('b', [_vm._v("examen clinique et des photographies")]), _vm._v(" intra-orales et extra-orales nous vous demanderons une "), _c('b', [_vm._v("imagerie 3D")]), _vm._v(" de type Cone Beam. Ainsi nous pourrons vous établir un "), _c('b', [_vm._v("diagnostic approfondi")]), _vm._v(" et un devis en conséquence.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 skew-c"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 colour-block"
  }, [_c('h2', {
    staticClass: "pb-1"
  }, [_vm._v("LE MEILLEUR TRAITEMENT NÉCESSITE LES MEILLEURES CONDITIONS")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_vm._v("\n           Nous nous engageons à vous fournir les "), _c('b', [_vm._v("meilleurs soins")]), _vm._v(" grâce à notre "), _c('b', [_vm._v("équipement de pointe")]), _vm._v(" (Implants Zimmer© ou Xive de Dentsply©, comblement osseux par BioBank© ou BioOss©, Somnomed©). Une "), _c('b', [_vm._v("traçabilité")]), _vm._v(" vous est systématiquement remise après chaque intervention. Le matériel utilisé, que cela soit sous anésthésie générale au bloc opératoire ou sous anesthésie locale, est soumis aux normes de "), _c('b', [_vm._v("stérilisations hospitalières")]), _vm._v(".\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 skew-cc"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 white-block"
  }, [_c('h2', {
    staticClass: "pb-1"
  }, [_vm._v("UNE PRISE EN CHARGE EN ÉQUIPE AVEC VOTRE DENTISTE TRAITANT")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_vm._v("\n             Notre spécialité comprend la "), _c('b', [_vm._v("chirurgie orale")]), _vm._v(" (extraction des dents de sagesse, kystes, etc.), l'"), _c('b', [_vm._v("implantologie")]), _vm._v(", les "), _c('b', [_vm._v("greffes osseuses")]), _vm._v(", les "), _c('b', [_vm._v("greffes gingivales")]), _vm._v(" et l’élaboration d’"), _c('b', [_vm._v("orthèses d’apnée du sommeil")]), _vm._v(". Nous nous mettrons en rapport avec votre dentiste traitant pour élaborer un plan de traitement global qui correspond à "), _c('b', [_vm._v("vos attentes")]), _vm._v(". Nous ne manquerons pas de le tenir informé lors de chaque étape du traitement car une "), _c('b', [_vm._v("bonne prise en charge")]), _vm._v(" passe par une "), _c('b', [_vm._v("communication claire")]), _vm._v(" entre tous.\n        ")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a60f8cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a60f8cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/engagement/engagement.component.html
// module id = 268
// module chunks = 1